import { createTheme, darken } from "@mui/material/styles";

export const theme = createTheme(
	{
		components: {
			MuiCssBaseline: {
				styleOverrides: {
					html: {
						fontSize: "12.8px"
					},
					body: {
						backgroundColor: "#f7f7f7"
					}
				}
			},
			MuiAppBar: {
				styleOverrides: {
					root: {
						backgroundColor: "#ffffff",
						boxShadow: "none"
					}
				}
			},
			MuiAutocomplete: {
				styleOverrides: {
					inputRoot: {
						padding: 0
					}
				}
			},
			MuiButton: {
				styleOverrides: {
					root: {
						textTransform: "none"
					},
					containedPrimary: {
						"&:hover": {
							backgroundColor: darken("#0a2b6f", 0.1)
						}
					},
					containedSecondary: {
						"&:hover": {
							backgroundColor: darken("#a2ad00", 0.1)
						}
					},
					outlinedPrimary: {
						borderWidth: "2px",
						borderColor: "#0a2b6f",
						"&:hover": {
							borderWidth: "2px",
							borderColor: "#0a2b6f"
						}
					}
				}
			},
			MuiButtonBase: {
				styleOverrides: {
					root: {
						"&.MuiTab-root": {
							minHeight: "3rem"
						}
					}
				}
			},
			MuiCardContent: {
				styleOverrides: {
					root: {
						":last-child": {
							paddingBottom: "1rem"
						}
					}
				}
			},
			MuiChip: {
				styleOverrides: {
					deleteIcon: {
						fontSize: "1.375rem"
					}
				}
			},
			MuiFormControl: {
				styleOverrides: {
					root: {
						backgroundColor: "#ffffff",
						borderColor: "#f7f7f7"
					}
				}
			},
			MuiTab: {
				styleOverrides: {
					root: {
						textTransform: "capitalize"
					}
				}
			},
			MuiTabs: {
				styleOverrides: {
					root: {
						minHeight: "3rem"
					}
				}
			}
		},
		palette: {
			primary: {
				main: "#0a2b6f"
			},
			secondary: {
				main: "#aab733"
			},
			background: {
				default: "#f7f7f7",
				paper: "#ffffff"
			},
			success: {
				main: "#aab733"
			},
			warning: {
				main: "#f9b42d"
			}
		},
		typography: {
			allVariants: {
				fontFamily: "Inter, sans-serif"
			},
			h4: {
				fontWeight: 600
			},
			h5: {
				fontWeight: 500,
				fontSize: "1rem"
			}
		},
		spacing: (factor: number) => `${0.25 * factor}rem`
	},
	{
		portalFramework: {
			pages: {
				login: {
					backgroundContainer: {}
				}
			}
		}
	}
);
